import React, { useState, useCallback } from 'react'
import ReactImageFallback from 'react-image-fallback'
import { MdLocationOn } from 'react-icons/md';
import { Button, Modal } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";

// images
import defaultUser from "../../assets/images/default_profile_pic.jpg";

export default function FreelanceBid(props) {
    
    const [comment, setComment] = useState(props?.bid?.detail ?? "");
    const [price, setPrice] = useState(props?.bid?.price ?? "");
    // react-bootstrap
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChangePrice = (e) => {
        let val = e.target.value;
        setPrice(val);
    }
    const handleChangeComment = (e) => {
        let val = e.target.value;
        setComment(val);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append("provider_id", props?.bid?.provider_id);
        formData.append("post_id", props?.bid?.post_id);
        formData.append("price", price);
        formData.append("description", comment);
    
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/bids/${props?.bid?.id}`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${props?.token}`,
          },
          body: formData
        })
          .then(r => r.json())
          .then(response => {
            if (response.success) {
                toast.success("Offer Updated Success!");
                handleClose();
                props.setAction("offer updated");
            } else {
                toast.error(response.message);
            }
          })    
      };

    return (
        <>
            <div className="bds-sectiontitle w-100">
                <div className="bg-gray theme-rounded-25 overflow-hidden mt-4">
                    <div className="bds-box bg-gray p-0 border-0 single_proposal">
                        <ReactImageFallback
                            src={`${process.env.REACT_APP_BASE_URL}/public/storage/${props?.bid?.user?.profile_image}`}
                            initialImage={defaultUser}
                            fallbackImage={defaultUser}
                        />                        
                        <div className="single_proposal_detail ms-4 my-1">
                            <h5 className='mb-0'>{props?.bid?.user?.first_name != null && props?.bid?.user?.last_name != null ? props?.bid?.user?.first_name + " " + props?.bid?.user?.last_name : props?.bid?.user?.name}</h5>
                            <p><small>Experience</small></p>
                            <p className='mb-2'>{props?.bid?.user?.experience}</p>
                            <p className="fw-bold">{props?.bid?.detail}</p>
                            {
                              props.posts.assign_post === null &&
                              <div className="">
                                  <button className="btn btn-link text-sky-blue text-decoration-none ps-0" type='button' onClick={handleShow}>Edit</button>
                                  <button className="btn btn-link text-sky-blue text-decoration-none" onClick={() => props.deleteBid(props?.bid.id)}>Delete</button>
                              </div>
                              
                            }
                        </div>
                        <div className="single_proposal_price">
                            ${props?.bid?.price}
                        </div>
                    </div>
                </div>
            </div>

            {/* <!-- Modal --> */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="p-4">
          <h3>Make an Offer</h3>

          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="form-group flex-column align-items-start px-0">
              <h6>Place Your Price</h6>
              <div className="bds-placeholderholder border">
                <span className="ps-3">$</span>
                <input
                  name="price"
                  type="number"
                  className="form-control bds-themeinput ps-2"
                  placeholder="Project Price"
                  value={price}
                  onChange={(e) => handleChangePrice(e)}
                />
              </div>
            </div>

            <div className="form-group flex-column align-items-start px-0">
              <h6>Cover Letter</h6>
              <div className="bds-placeholderholder border theme-rounded-25 p-2">
                <textarea
                  name="description"
                  className="form-control bds-themeinput ps-2"
                  placeholder="Project Price"
                  value={comment}
                  onChange={(e) => handleChangeComment(e)}
                />
              </div>
            </div>

            <button className="btn bds-btn-solid-lg btn-primary ms-auto d-block" type="submit">Update your offer</button>
          </form>
        </Modal.Body>
      </Modal>

        <ToastContainer />

        </>
    )
}
